import pick from 'lodash/pick'
import { User } from 'shared/types/User'

// Filter user data with minimum fields
export function pruneUserFields(userData: User) {
  const USER_FIELDS = ['email', 'id', 'isGuest', 'name', 'username']
  return pick(userData, USER_FIELDS)
}
